export const primary = '#c3fde1';
export const accent = '#f1aa69';
export const background = '#1f2124';
export const green = '#00c4a7';
export const red = '#ff6f62';
